var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountvoucher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3121 40.7036L10 24.527V27.8317C10 28.7075 10.3499 29.5502 10.9831 30.1615L23.9628 43.0334C25.2624 44.3222 27.3785 44.3222 28.6781 43.0334L39.0253 32.7723C40.3249 31.4834 40.3249 29.3849 39.0253 28.0961L26.3121 40.7036Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9628 34.7675C24.6126 35.4119 25.4624 35.7424 26.3121 35.7424C27.1619 35.7424 28.0117 35.4119 28.6615 34.7675L39.0086 24.5064C40.3082 23.2175 40.3082 21.119 39.0086 19.8302L26.0289 6.95837C25.4124 6.34699 24.5626 6 23.6795 6H13.3324C11.4996 6 10 7.48712 10 9.30471V19.5658C10 20.4416 10.3499 21.2843 10.9831 21.8956L23.9628 34.7675ZM13.3324 9.30471H23.6795L36.6593 22.1765L26.3121 32.4377L13.3324 19.5658V9.30471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0814 15.0879C18.2316 15.0879 19.1641 14.1632 19.1641 13.0225C19.1641 11.8818 18.2316 10.9571 17.0814 10.9571C15.9311 10.9571 14.9986 11.8818 14.9986 13.0225C14.9986 14.1632 15.9311 15.0879 17.0814 15.0879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountvoucher);
export default __webpack_public_path__ + "static/media/discountvoucher.3f58f34f54350086b8e22702f5de2b4d.svg";
export { ForwardRef as ReactComponent };